import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { scrollToTop } from "@/utils/scroll";

type BackToTopComponentProps = {
    visible: boolean;
    bottomControlsVisible: boolean;
};

const BackToTopComponent = ({
    visible,
    bottomControlsVisible
}: BackToTopComponentProps) => {
    const { t } = useGranite();

    return (
        <Button
            className={cn(
                "tw:fixed tw:right-3 tw:bottom-2 tw:layer-overlay/[0] tw:md:right-8 tw:md:bottom-8",
                "tw:transition-opacity tw:transition-visibility tw:ease-in-out",
                visible
                    ? "tw:opacity-100 tw:visible tw:duration-[0s,200ms]"
                    : "tw:opacity-0 tw:invisible tw:duration-[200ms,0s]",
                { "tw:bottom-16 tw:md:bottom-12": bottomControlsVisible }
            )}
            type={"button"}
            color={"gray"}
            onClick={() => scrollToTop()}
            aria-label={t("accessibility.backToTopButton.label")}
        >
            <i className="las la-angle-up"></i>
        </Button>
    );
};

export { BackToTopComponent };
